import CONFIG_KEYS from "../config";
import { ApiClient } from "../generated/api";
import { customFetch } from "../middlewares/custom-fetch";

const BASE = `${CONFIG_KEYS.baseUrl}/api/Messaging`;

export interface ConversationDto {
  token: string;
  otherUserToken: string;
  otherUserName: string;
  otherUserAvatar?: string;
  lastMessageBody?: string;
  lastMessageDate?: string;
  unreadCount: number;
}

export interface MessageDto {
  token: string;
  senderToken: string;
  senderName: string;
  senderAvatar?: string;
  body: string;
  sentAt: string;
  isRead: boolean;
  isOwn: boolean;
}

export class MessagingService {
  private api: ApiClient;
  
    constructor(navigate?: (url: string) => void) {
      this.api = new ApiClient(CONFIG_KEYS.baseUrl, {
        fetch: customFetch
      });
    }
   

    
  async getUnreadCount(): Promise<number> {
    try {
      const res = await this.api.unreadCount();
      return (res as unknown as number) ?? 0;
    } catch { return 0; }
  }

  async getConversations(): Promise<ConversationDto[]> {
    const res = await this.api.conversations();
    return (res as unknown as ConversationDto[]) ?? [];
  }

  async startConversation(otherUserToken: string): Promise<ConversationDto | null> {
    const res = await this.api.start(otherUserToken);
    return (res as unknown as ConversationDto) ?? null;
  }

  async getMessages(conversationToken: string, page = 1, pageSize = 50): Promise<MessageDto[]> {
    const res = await this.api.messagesAll(conversationToken,page,pageSize);
    return (res as unknown as MessageDto[]) ?? [];
  }

  async sendMessage(conversationToken: string, body: string): Promise<MessageDto | null> {
    const res = await this.api.messages(conversationToken, { body });
    return (res as unknown as MessageDto) ?? null;
  }
}
